import { useParams, useSearchParams } from "react-router-dom";
import trainingsAPI from "../../services/trainings";
import FamilyTopNavbar from "./components/FamilyTopNavbar";
import { useEffect, useState } from "react";
import familyAPI from "../../services/family";
import PreCheck from "./components/PreCheck";
import Check from "./components/Check";
import FamilyRegistration from "./components/FamilyRegistration";
import "./FamilyPage.css";
export async function loader({ params }) {
  const result = await trainingsAPI.GetOneTraining(params.schoolId, params.trainingId);
  return { training: result?.data };
}

export function FamilyPage() {

  const params = useParams();
  const registrationAccessKey = params.registrationAccessKey;

  const [searchParams] = useSearchParams();
  const c = searchParams.get('c');
  const m = searchParams.get('m');
  const obs = searchParams.get('obs');
  const rakct = searchParams.get('rakct') ? parseInt(searchParams.get('rakct')) : -1;

  const [accessToken, setAccessToken] = useState(null);
  const [registrationAccessKeyCheckType, setRegistrationAccessKeyCheckType] = useState(rakct);
  const [campaignId, setCampaignId] = useState(c);
  const [mailId, setMailId] = useState(m);
  const [error, setError] = useState(null);

  useEffect(() => {
    setRegistrationAccessKeyCheckType(rakct);
  }, [rakct]);

  useEffect(() => {
    setCampaignId(c);
  }, [c]);

  useEffect(() => {
    setMailId(m);
  }, [m]);

  const handleSubmitPreCheck = (recaptchaToken) => {

    familyAPI.PreCheck(registrationAccessKey, recaptchaToken, campaignId, mailId).then((res) => {
      if (res.error) {
        setError("Votre clé d'accès est invalide");
      } else {
        setRegistrationAccessKeyCheckType(res.check_type);
      }
    }).catch((err) => {
      console.log("err", err);
    });
  }

  const handleSubmitCheck = (recaptchaToken, otp) => {

    familyAPI.Check(registrationAccessKey, recaptchaToken, registrationAccessKeyCheckType, otp, campaignId, mailId).then((res) => {
      if (res.error) {
        setError("Votre clé d'accès est invalide");
      } else {
        if (res.success) {
          setAccessToken(res.access_token);
        } else {
          setError("Votre clé d'accès est invalide");
        }
      }
    }).catch((err) => {
      console.log("err", err);
      setError("Une erreur est survenue");
    });
  }

  useEffect(() => {
    if (accessToken) {
      // load family area
    }
  }, [accessToken]);

  return (
    <div className="family-page-root">
      <div className="family-page-shell min-h-screen flex flex-column">
        <div className="family-navbar-wrap">
          <FamilyTopNavbar />
        </div>

        <div className="family-page-content flex flex-column flex-auto">
          {!error && !accessToken && (
            <div className="family-auth-wrap">
              <div className="family-auth-intro">
                <div className="family-auth-title">Espace Famille</div>
                <div className="family-auth-subtitle">Confirmez vos inscriptions et mettez a jour vos informations de contact.</div>
              </div>
              {registrationAccessKeyCheckType === -1 && <PreCheck onSubmit={handleSubmitPreCheck} />}
              {registrationAccessKeyCheckType >= 0 && <Check checkType={registrationAccessKeyCheckType} onSubmit={handleSubmitCheck} />}
            </div>
          )}

          {error && (
            <div className="family-error-wrap">
              <div className="family-error-card">
                <div className="flex flex-column align-items-center justify-content-center gap-3">
                  <i className="pi pi-exclamation-triangle text-5xl family-error-icon"></i>
                  <span className="text-2xl text-center">{error}</span>
                </div>
                <div className="mt-3 text-lg text-center">Merci de contacter l'administration de l'ecole</div>
              </div>
            </div>
          )}

          {accessToken && (
            <div className="family-registration-wrap">
              <FamilyRegistration accessToken={accessToken} openObservationsForStudentId={obs} />
            </div>
          )}
        </div>
      </div>
    </div>
  )
}